import { Card } from 'ui/components/primitives';
import { mixins, styled, theme, utils } from 'ui/theme';

export const Modal = {
  Card: styled(Card)`
    grid-template-rows: auto 1fr auto;
    height: 100%;

    &[data-variant='contextual'],
    &[data-align='top-center'] {
      border-radius: 0 0 ${theme.radii.large} ${theme.radii.large};
    }

    &[data-variant='contextual'],
    &[data-align='top-left'] {
      border-radius: 0 0 ${theme.radii.large} 0;
    }

    &[data-variant='contextual'],
    &[data-align='top-right'] {
      border-radius: 0 0 0 ${theme.radii.large};
    }

    &[data-variant='contextual'],
    &[data-align='center-left'] {
      border-radius: 0 ${theme.radii.large} ${theme.radii.large} 0;
    }

    &[data-variant='contextual'],
    &[data-align='center-center'] {
      border-radius: ${theme.radii.large};
    }

    &[data-variant='contextual'],
    &[data-align='center-right'] {
      border-radius: ${theme.radii.large} 0 0 ${theme.radii.large};
    }

    &[data-variant='contextual'],
    &[data-align='bottom-left'] {
      border-radius: 0 ${theme.radii.large} 0 0;
    }

    &[data-variant='contextual'],
    &[data-align='bottom-center'] {
      border-radius: ${theme.radii.large} ${theme.radii.large} 0 0;
    }

    &[data-variant='contextual'],
    &[data-align='bottom-right'] {
      border-radius: ${theme.radii.large} 0 0 0;
    }

    &[data-radius='square'] {
      border-radius: ${theme.radii.sharp};
    }

    &[data-context='immersive'] {
      border-radius: ${theme.radii.sharp};

      ${utils.media.min('l')`
        border-radius: ${theme.radii.large};
      `}
    }

    &[data-variant='confirmation'],
    &[data-align='center-center'] {
      border-radius: ${theme.radii.small};
    }
  `,

  Component: styled('div')`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndices.modal};
    visibility: hidden;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;

    /* ALIGNMENT */
    &[data-align='top-center'] {
      justify-content: center;
      align-items: start;
    }

    &[data-align='top-left'] {
      justify-content: start;
      align-items: start;
    }

    &[data-align='top-right'] {
      justify-content: end;
      align-items: start;
    }

    &[data-align='center-left'] {
      justify-content: start;
      align-items: center;
    }

    &[data-align='center-center'] {
      justify-content: center;
      align-items: center;
    }

    &[data-align='center-right'] {
      justify-content: end;
      align-items: center;
    }

    &[data-align='bottom-left'] {
      justify-content: start;
      align-items: end;
    }

    &[data-align='bottom-center'] {
      justify-content: center;
      align-items: end;
    }

    &[data-align='bottom-right'] {
      justify-content: end;
      align-items: end;
    }

    /* VISIBLE */
    &[data-visible='true'] {
      ${utils.animation('fadeIn')};
      visibility: visible;
    }

    ${utils.media.max('m')`
      padding: ${theme.space[4]} ${theme.space[4]} ${theme.space[0]};
    `}

    h6 {
      ${utils.media.max('m')`
        max-width: 90%;
      `}
    }
  `,

  Dialog: styled('div')`
    position: relative;

    /* SIZE */
    &[data-size='small'] {
      width: 50%;
      max-width: ${theme.screens.s};
    }

    &[data-size='medium'] {
      width: 70%;
      max-width: ${theme.screens.m};

      ${utils.media.max('m')`
        width: 90%;
      `}
    }

    &[data-size='large'] {
      width: 90%;
      max-width: ${theme.screens.l};
    }

    /* VARIANT */
    &[data-context='immersive'] {
      ${utils.media.max('s')`
        width: 100%;
        height: 100%;
      `}
    }

    /* STRETCH */
    &[data-stretch='true'] {
      ${utils.media.max('s')`
        width: 100%;
      `}
    }
  `,

  Header: styled('div')`
    ${mixins.baseFont}
    display: flex;
    padding: ${theme.space[6]} ${theme.space[6]} ${theme.space[0]};
    font-size: ${theme.fontSizes.xl};

    ${utils.media.max('m')`
      padding: ${theme.space[4]} ${theme.space[4]} ${theme.space[0]};
    `}
  `,
};
